import { ModalLoadingLogic as ModalLoading } from './ModalLoading.logic'

export default ModalLoading
